/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function DoorClosedIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="door-closed"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M16 12L16 12" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(166.667)} data-tinysvg-stroke-width="166.667" />
          <path d="M2.5 21.5L21.5 21.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M4.5 21.5L4.5 4.5C4.5 3.395 5.395 2.5 6.5 2.5L17.5 2.5C18.605 2.5 19.5 3.395 19.5 4.5L19.5 21.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
